import React, { createContext, useState, useContext } from 'react';

type OutputConfigContextType = [OutputConfig, (outputConfig: OutputConfig) => void];

interface OutputConfig {
    device?: MediaDeviceInfo;
    stereo: number;
}

const OutputConfigContext = createContext<OutputConfigContextType | undefined>(undefined);

export const OutputConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [outputConfig, setOutputConfig] = useState<OutputConfig>({ stereo: 0 });

    return (
        <OutputConfigContext.Provider value={[outputConfig, setOutputConfig]}>
            {children}
        </OutputConfigContext.Provider>
    );
};

export const useOutputConfig = () => {
    const context = useContext(OutputConfigContext);

    if (!context) {
        throw new Error('useOutputDevice must be used within an OutputDeviceProvider');
    }

    return context;
};
